import { render, staticRenderFns } from "./_base-multiple-category.vue?vue&type=template&id=310a2d52&"
import script from "./_base-multiple-category.vue?vue&type=script&lang=js&"
export * from "./_base-multiple-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports